import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'digihaven-report-detail-container',
    templateUrl: './report-detail-container.component.html'
})
export class ReportDetailContainerComponent {}
